import type { ParticipantRole, Permission, RoomPermissions } from "@vc/models"

// Default permission matrix (mirrors Google Meet / Teams model)
export const DEFAULT_PERMISSIONS: RoomPermissions = {
  chat: ["host", "moderator", "presenter", "attendee"],
  "file-share": ["host", "moderator", "presenter", "attendee"],
  "screen-share": ["host", "moderator", "presenter"],
  recording: ["host", "moderator"],
  "lobby-promote": ["host", "moderator"],
  "role-modify": ["host", "moderator"],
  annotation: ["host", "moderator", "presenter"],
  "breakout-manage": ["host", "moderator"],
  "lock-meeting": ["host", "moderator"],
  "clear-chat": ["host", "moderator"],
  // Raising and closing polls. Matches what the API enforces (poll.router.ts
  // canModerate accepts host and co-host), so the button is only ever shown to
  // someone the server would actually accept it from.
  "poll-manage": ["host", "moderator"],
}

export const hasPermission = (
  role: ParticipantRole,
  permission: Permission,
  permissions: RoomPermissions = DEFAULT_PERMISSIONS,
): boolean => permissions[permission].includes(role)
